import { Component, OnInit, Input } from '@angular/core';
import { Partner } from '@fitscovery/partner/data-access';

@Component({
  selector: 'fitscovery-ui-groove-section-last',
  templateUrl: './ui-groove-section-last.component.html',
  styleUrls: ['./ui-groove-section-last.component.scss']
})
export class UiGrooveSectionLastComponent implements OnInit {
  @Input() partner: Partner;
  @Input() isRound: boolean;
  @Input() isSmall: boolean;

  constructor() { }

  ngOnInit(): void {
    this.isRound = !this.isRound
    ? false
    : this.isRound;
  this.isSmall = !this.isSmall
    ? false
    : this.isSmall;
  }

}
